import { PropsWithChildren } from "react";
import { useParams } from "react-router";
import { Link, LinkProps } from "react-router-dom";

export const TenantAwareLink: React.FC<PropsWithChildren<LinkProps>> = ({
  to,
  children,
  ...rest
}) => {
  const { orgSlug } = useParams();
  return (
    <Link to={`/o/${orgSlug}/${to}`} {...rest}>
      {children}
    </Link>
  );
};
